import React from 'react';

import spinChallenge from '../../../images/v1/rewards/spinChallenge.svg'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SpinAndWin = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/spin-wheel');
  };

  const {t} = useTranslation();

  return (
    <div className="spin-and-win" onClick={handleClick}>
      <div className="blur blur-1"></div>
      <div className="blur blur-2"></div>
      <div className="blur blur-3"></div>
      <div className="content">
        <div className="text">
          <h2 className='stroke-color-black'>{t('spin_amp_win')}</h2>
          <p className='stroke-color-black'>{t('play_game_msg')} </p>
          <button className="play-now">{t('play_now')} </button>
        </div>
        <div className="image">
          <img src={spinChallenge} alt="Spin wheel" />
        </div>
      </div>
      <style jsx>{`
        .spin-and-win {
          background-color: #A5FFFB;
          border-radius: 15px;
          padding: 20px;
          position: relative;
          overflow: hidden;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;
        }

        .spin-and-win:hover {
          transform: translateY(-4px);
        }

        .play-now {
          background-color: #008080;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 20px;
          font-weight: bold;
          cursor: pointer;
        }

      `}</style>
    </div>
  );
};

export default SpinAndWin;